import SelectedDanceDto from "../dto/selected_dance";

export default class SelectedDance
{
	public grade!: string;
	public category!: string;
	public group!: string;
	public bars!: string;
	public speed!: string;
	public trackListing!: string;
	public audioFilename!: string;
	public audioElement!: HTMLAudioElement;
	public isPlaying!: boolean;
	public isSelected!: boolean;

	constructor(dto: SelectedDanceDto)
	{
		Object.assign(this, dto);
	}
}